import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-obsidian text-ivory">
      {/* Header */}
      <header className="border-b border-amber/[0.08] bg-obsidian/95 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 py-5">
          <Link to="/" className="inline-flex items-center gap-2 text-amber hover:text-amber/80 transition-colors font-body text-sm">
            <ArrowLeft size={16} />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl md:text-5xl font-light text-ivory mb-4">Refund & Cancellation Policy</h1>
        <p className="text-ivory/30 font-body text-sm mb-12">Last updated: February 2026</p>

        <div className="space-y-8 font-body text-ivory/70 leading-relaxed">
          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">1. Cancellation by Guest</h2>
            <div className="bg-amber/[0.05] border border-amber/[0.1] rounded-sm p-6 mb-4">
              <h3 className="text-amber font-medium mb-3">Cancellation Timeline & Refund</h3>
              <ul className="space-y-3">
                <li className="flex justify-between items-center border-b border-amber/[0.08] pb-2">
                  <span>More than 48 hours before event</span>
                  <span className="text-amber font-medium">Full Refund (100%)</span>
                </li>
                <li className="flex justify-between items-center border-b border-amber/[0.08] pb-2">
                  <span>24-48 hours before event</span>
                  <span className="text-amber font-medium">50% Refund</span>
                </li>
                <li className="flex justify-between items-center">
                  <span>Less than 24 hours before event</span>
                  <span className="text-ivory/50 font-medium">No Refund</span>
                </li>
              </ul>
            </div>
            <p>To cancel your booking, please contact us via WhatsApp or phone at +91 8876133284.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">2. Rescheduling</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Rescheduling requests made 24+ hours in advance will be accommodated subject to availability</li>
              <li>One free reschedule is allowed per booking</li>
              <li>Additional rescheduling may incur a ₹200 admin fee</li>
              <li>Rescheduled bookings must be used within 30 days of original date</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">3. Cancellation by The Curated Experience</h2>
            <p className="mb-4">We may cancel your booking due to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Weather conditions:</strong> Heavy rain, storms, or unsafe conditions</li>
              <li><strong>Technical issues:</strong> Equipment malfunction beyond our control</li>
              <li><strong>Unforeseen circumstances:</strong> Natural disasters, emergencies</li>
            </ul>
            <p className="mt-4 text-amber">In all such cases, you will receive a full refund or free rescheduling to your preferred available date.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">4. No-Show Policy</h2>
            <p>If you do not arrive for your scheduled booking without prior notice:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>No refund will be provided</li>
              <li>The booking cannot be rescheduled</li>
              <li>We recommend contacting us if you're running late</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">5. Refund Process</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Refunds will be processed within 5-7 business days</li>
              <li>Amount will be credited to the original payment method</li>
              <li>Bank processing times may vary (additional 2-5 days)</li>
              <li>You will receive confirmation via WhatsApp/email once refund is initiated</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">6. Partial Experience</h2>
            <p>If your experience is interrupted due to factors within our control (e.g., technical issues during the screening), we will offer:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>Partial refund proportional to the disruption, OR</li>
              <li>Complimentary rebooking for another date</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading text-ivory mb-4">7. Contact for Refunds</h2>
            <p className="mb-4">To request a cancellation or refund, please contact us with your booking details:</p>
            <div className="bg-amber/[0.05] border border-amber/[0.1] rounded-sm p-6">
              <p className="text-amber mb-2">WhatsApp/Phone: +91 8876133284</p>
              <p className="text-amber mb-2">Email: support@tcexp.in</p>
              <p className="text-ivory/50 text-sm mt-4">Please include your name, booking date, and phone number used during booking.</p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-amber/[0.08] py-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-ivory/30 font-body text-sm">© 2026 The Curated Experience. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
